import { render } from "./departement-card.vue?vue&type=template&id=40a44935"
import script from "./departement-card.vue?vue&type=script&lang=js"
export * from "./departement-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__